import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { termsApi } from "../api/termsApi";

export default function useViewTermsPrivacy(
    options?: UseCustomMutationOptions,
): UseMutationResult<string, unknown, string> {
    return useMutation(async (type: string) => {
        const res = await termsApi.viewTermsAndConditionUrl(type);
        return res.data;
    }, options);
}
